"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = readFile;
var _promises = _interopRequireDefault(require("node:fs/promises"));
async function readFile(path, schema, options) {
  const fileParser = options?.parser ?? JSON.parse;
  const rawJson = fileParser(await _promises.default.readFile(path, {
    encoding: 'utf8'
  }));
  if (options?.throwOnZodError) {
    return schema.parse(rawJson);
  }
  const result = schema.safeParse(rawJson);
  return result.success ? result.data : result.error;
}
